import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { IAddressSuggestProps, TAddressValue, TUseAddressSuggestProps } from '../types';
import { IAddressSuggestion } from '../../../types/address';
import { TThunkDispatch } from '../../../types/redux';
import { getAddressSuggest } from '../../../actions/suggest';

export function useAddressSuggest({ value, error, onChange, onBlur }: TUseAddressSuggestProps): IAddressSuggestProps {
  const dispatch = useDispatch<TThunkDispatch>();
  const requestSuggestions = useCallback((value: string) => dispatch(getAddressSuggest(value)), [dispatch]);

  const handleItemClick = useCallback(
    (address: IAddressSuggestion) => {
      onChange(address.data);
    },
    [onChange],
  );
  const handleChange = useCallback(
    (value: string) => {
      const resultValue: TAddressValue = value
        ? {
            address: value,
            displayName: value,
          }
        : null;
      onChange(resultValue);
    },
    [onChange],
  );

  return {
    value: value?.displayName || '',
    error,
    requestSuggestions,
    onItemClick: handleItemClick,
    onChange: handleChange,
    onBlur,
  };
}
